import React, { FC } from "react";
import {
  StyleSheet,
  Text,
  TextStyle,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";
import { Checkbox as PaperCheckbox } from "react-native-paper";

export type CheckboxPressEvent = {
  name: string;
  checked: boolean;
};

interface CheckboxProps {
  name: string;
  text?: string;
  checked?: boolean;
  disabled?: boolean;
  onPressCheckbox?: (event: CheckboxPressEvent) => void;
  styles?: ViewStyle;
  textStyles?: TextStyle;
}

const Checkbox: FC<CheckboxProps> = ({
  name,
  text,
  checked,
  disabled,
  onPressCheckbox,
  styles,
  textStyles,
}) => {
  const onPressCheckboxHandle = () => {
    onPressCheckbox?.({
      name: name,
      checked: !checked,
    });
  };

  return (
    <TouchableWithoutFeedback
      onPress={onPressCheckboxHandle}
      disabled={disabled}
    >
      <View
        style={[
          checkboxStyles.viewContainer,
          styles,
          { opacity: disabled ? 0.6 : 1 },
        ]}
      >
        <PaperCheckbox.Android
          status={checked ? "checked" : "unchecked"}
          color="orange"
          uncheckedColor="#aaa"
        />
        <Text style={[checkboxStyles.text, textStyles]}>{text}</Text>
      </View>
    </TouchableWithoutFeedback>
  );
};

export default Checkbox;

const checkboxStyles = StyleSheet.create({
  viewContainer: {
    flexDirection: "row",
    marginVertical: 5,
    gap: 5,
    alignItems: "center",
  },
  text: {},
});
